import { render, staticRenderFns } from "./homeConfigList.vue?vue&type=template&id=0cad7b43&scoped=true"
import script from "./homeConfigList.vue?vue&type=script&lang=js"
export * from "./homeConfigList.vue?vue&type=script&lang=js"
import style0 from "./homeConfigList.vue?vue&type=style&index=0&id=0cad7b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad7b43",
  null
  
)

export default component.exports